import styled from '@emotion/styled';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 120px auto 80px 60px;
`
